import axiosInstance from '../axiosConfig';

export default {
  async getProductById(payload) {
    const response = await axiosInstance.post('/EcomBuscarProdPorId', payload);
    return response.data;
  },
};
